[
  {
    "id": "czlowiek",
    "name": "Człowiek",
    "description": "Wszechstronni i uparci — dobrze radzą sobie w każdej roli.",
    "traits": [
      {
        "name": "Wszechstronność",
        "description": "+10% doświadczenia"
      },
      {
        "name": "Smykałka do handlu",
        "description": "+15% złota z wypraw"
      },
      {
        "name": "Drugi oddech",
        "description": "co 45 s: +40% regeneracji i +10% szybkości na 8 s"
      }
    ],
    "modifiers": [
      {
        "stat": "xpGain",
        "op": "mul",
        "value": 0.1
      },
      {
        "stat": "goldGain",
        "op": "mul",
        "value": 0.15
      }
    ],
    "periodic": [
      {
        "name": "Drugi oddech",
        "every": 45,
        "duration": 8,
        "modifiers": [
          {
            "stat": "regen",
            "op": "add",
            "value": 2
          },
          {
            "stat": "moveSpeed",
            "op": "mul",
            "value": 0.1
          }
        ]
      }
    ],
    "look": {
      "skinTone": "#c99674",
      "hair": "#5a3a22",
      "build": [
        1,
        1
      ],
      "female": {
        "hair": "#7a4a26",
        "build": [
          0.9,
          0.96
        ]
      }
    }
  },
  {
    "id": "krasnolud",
    "name": "Krasnolud",
    "description": "Niscy, krępi i twardzi jak skała, z której wyszli.",
    "traits": [
      {
        "name": "Kamienna skóra",
        "description": "+8 pancerza"
      },
      {
        "name": "Górnicza krzepa",
        "description": "+10% maksymalnego zdrowia"
      },
      {
        "name": "Nos do skarbów",
        "description": "skrzynie pojawiają się o 15% częściej"
      }
    ],
    "modifiers": [
      {
        "stat": "armor",
        "op": "add",
        "value": 8
      },
      {
        "stat": "maxHealth",
        "op": "mul",
        "value": 0.1
      },
      {
        "stat": "chestRate",
        "op": "mul",
        "value": 0.15
      }
    ],
    "periodic": [],
    "look": {
      "skinTone": "#c08664",
      "hair": "#8a3b1c",
      "build": [
        1.2,
        0.82
      ],
      "female": {
        "hair": "#a2502a",
        "build": [
          1.1,
          0.8
        ]
      }
    }
  },
  {
    "id": "ork",
    "name": "Ork",
    "description": "Wojownicy z krwi i kości, którzy w bitwie rosną w siłę.",
    "traits": [
      {
        "name": "Gniew przodków",
        "description": "co 40 s: +30% obrażeń na 10 s"
      },
      {
        "name": "Twarda skóra",
        "description": "+4 pancerza"
      },
      {
        "name": "Siła klanu",
        "description": "+5% obrażeń"
      }
    ],
    "modifiers": [
      {
        "stat": "armor",
        "op": "add",
        "value": 4
      },
      {
        "stat": "damage",
        "op": "mul",
        "value": 0.05
      }
    ],
    "periodic": [
      {
        "name": "Gniew przodków",
        "every": 40,
        "duration": 10,
        "modifiers": [
          {
            "stat": "damage",
            "op": "mul",
            "value": 0.3
          }
        ]
      }
    ],
    "look": {
      "skinTone": "#6f8a4a",
      "hair": "#1e1a16",
      "build": [
        1.16,
        1.04
      ],
      "female": {
        "build": [
          1.04,
          1.0
        ]
      }
    }
  },
  {
    "id": "elf",
    "name": "Elf",
    "description": "Smukli i bystrzy; ich strzały i czary rzadko chybiają.",
    "traits": [
      {
        "name": "Zwinność",
        "description": "+6% szybkości ruchu"
      },
      {
        "name": "Bystre oko",
        "description": "+3% szansy na krytyk"
      },
      {
        "name": "Spokój umysłu",
        "description": "−5% czasu odnowienia umiejętności"
      }
    ],
    "modifiers": [
      {
        "stat": "moveSpeed",
        "op": "mul",
        "value": 0.06
      },
      {
        "stat": "critChance",
        "op": "add",
        "value": 0.03
      },
      {
        "stat": "cooldown",
        "op": "mul",
        "value": -0.05
      }
    ],
    "periodic": [],
    "look": {
      "skinTone": "#e2c7ad",
      "hair": "#d8d0b8",
      "build": [
        0.9,
        1.06
      ],
      "female": {
        "build": [
          0.84,
          1.03
        ]
      }
    }
  },
  {
    "id": "nieumarly",
    "name": "Nieumarły",
    "description": "Wrócili zza grobu. Ból ich nie obchodzi, głód — owszem.",
    "traits": [
      {
        "name": "Ciało bez bólu",
        "description": "+0,6 zdrowia na sekundę"
      },
      {
        "name": "Mroczna wola",
        "description": "co 60 s: +15 pancerza na 6 s"
      },
      {
        "name": "Zimny umysł",
        "description": "+5% doświadczenia"
      }
    ],
    "modifiers": [
      {
        "stat": "regen",
        "op": "add",
        "value": 0.6
      },
      {
        "stat": "xpGain",
        "op": "mul",
        "value": 0.05
      }
    ],
    "periodic": [
      {
        "name": "Mroczna wola",
        "every": 60,
        "duration": 6,
        "modifiers": [
          {
            "stat": "armor",
            "op": "add",
            "value": 15
          }
        ]
      }
    ],
    "look": {
      "skinTone": "#8d9884",
      "hair": "#3a3a36",
      "build": [
        0.92,
        1
      ],
      "female": {
        "build": [
          0.86,
          0.97
        ]
      }
    }
  },
  {
    "id": "troll",
    "name": "Troll",
    "description": "Wysocy łowcy z dżungli; rany zabliźniają im się w oczach.",
    "traits": [
      {
        "name": "Zabliźnianie",
        "description": "+1 zdrowia na sekundę"
      },
      {
        "name": "Trans łowcy",
        "description": "co 35 s: −30% czasu odnowienia na 10 s"
      },
      {
        "name": "Celny rzut",
        "description": "+3% szansy na krytyk"
      }
    ],
    "modifiers": [
      {
        "stat": "regen",
        "op": "add",
        "value": 1
      },
      {
        "stat": "critChance",
        "op": "add",
        "value": 0.03
      }
    ],
    "periodic": [
      {
        "name": "Trans łowcy",
        "every": 35,
        "duration": 10,
        "modifiers": [
          {
            "stat": "cooldown",
            "op": "mul",
            "value": -0.3
          }
        ]
      }
    ],
    "look": {
      "skinTone": "#7c8a68",
      "hair": "#3b2e22",
      "build": [
        1.04,
        1.14
      ],
      "female": {
        "build": [
          0.96,
          1.1
        ]
      }
    }
  }
]
